import React, { ReactElement, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { RiCloseLine } from "@remixicon/react";
import { useDeleteMessageMutation } from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";
import { HtmlRenderer } from "../../html-render/HtmlRenderer";
import Alert from "../../theme/alert/Alert";
import { TicketItem } from "../../../contexts/ticket-state";
import { useTheme } from "../../../contexts/Theme";

interface DeleteMessageActionProps {
    text: string;
    iconOnly?: boolean;
    ticketMessageId: string;
    ticketItem?: TicketItem;
    isScheduled?: boolean;
}

export default function DeleteMessageAction({
    ticketMessageId, text, iconOnly, ticketItem, isScheduled,
}: DeleteMessageActionProps): ReactElement {
    const [isShowCreate, setIsShowCreate] = useState(false);

    const [body, setBody] = useState(text);
    const theme = useTheme();

    const [deleteMessage] = useDeleteMessageMutation();

    useEffect(() => {
        setBody(text);
    }, [isShowCreate]);

    const onSave = async () => {
        if (ticketItem) {
            ticketItem.deleteMessage(ticketMessageId);
        } else {
            await deleteMessage({
                variables: {
                    ticketMessageId,
                },
            });
        }

        setIsShowCreate(false);
    };

    return (
        <>
            <Confirm
                shouldShow={isShowCreate}
                onConfirm={onSave}
                size="lg"
                confirmText="Delete"
                confirmVariant="danger"
                onHide={() => setIsShowCreate(false)}
                dialogClassName="mt-5"
            >
                <div>
                    <div>
                        Are you sure you want to delete the
                        {isScheduled ? " scheduled " : " "}
                        message:
                    </div>

                    <Alert variant="primary" className="mt-2">
                        <HtmlRenderer html={body} shouldTrimBottom />
                    </Alert>
                </div>
            </Confirm>

            <Dropdown.Item
                onClick={() => setIsShowCreate(true)}
                className={theme.isV3 ? "" : "text-white"}
                title={iconOnly ? "Delete Message" : undefined}
            >
                {iconOnly ? <RiCloseLine /> : "Delete Message"}
            </Dropdown.Item>
        </>
    );
}

DeleteMessageAction.defaultProps = {
    iconOnly: false,
    ticketItem: undefined,
    isScheduled: false,
};
